module.exports = __webpack_public_path__ + "static/ubereat-fc9e0489913e1162edffc4841c0fbada.png";